<p-button
  icon="pi pi-eye"
  [rounded]="true"
  [text]="true"
  [pTooltip]="l('::View')"
  tooltipPosition="left"
  (onClick)="onClick()" />